import { defineMessages } from './define';
import { useLocale, useT } from './hooks';
import { LOCALE_NAMES, LOCALE_SHORT } from './locales';

const messages = defineMessages({
  label: { id: 'common.language.label', defaultMessage: 'Язык интерфейса' },
});

/**
 * Переключатель языка. Каждый язык назван самоназванием и помечен `lang`:
 * экранный диктор читает «Oʻzbekcha» по-узбекски, а не по правилам
 * текущего языка. Языков меньше двух — переключателя нет: выбирать не из чего.
 */
export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const t = useT();
  const { locale, locales, setLocale } = useLocale();
  if (locales.length < 2) return null;

  return (
    <div className={`langsw ${className}`} role="group" aria-label={t(messages.label)}>
      {locales.map((item) => (
        <button
          key={item}
          type="button"
          lang={item}
          className={`langsw__btn focus-ring ${item === locale ? 'is-on' : ''}`}
          aria-pressed={item === locale}
          title={LOCALE_NAMES[item]}
          onClick={() => setLocale(item)}
        >
          <span aria-hidden="true">{LOCALE_SHORT[item]}</span>
          <span className="visually-hidden">{LOCALE_NAMES[item]}</span>
        </button>
      ))}
    </div>
  );
}
